interface Props {
  toolCallId: string;
  toolName: string;
  prompt: string;
  onApprove: () => void;
  onReject: () => void;
}

export function ApprovalModal({ toolName, prompt, onApprove, onReject }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-ink-950/40 backdrop-blur-sm" onClick={onReject} />

      {/* Dialog */}
      <div className="relative mx-4 w-full max-w-md animate-slide-up rounded-2xl bg-white p-6 shadow-elevated">
        {/* Warning icon */}
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-amber-50">
          <svg className="h-6 w-6 text-amber-600" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M8 1L1 14h14L8 1z" />
            <path d="M8 6v3" />
            <circle cx="8" cy="12" r="0.5" fill="currentColor" />
          </svg>
        </div>

        <h2 className="text-center text-base font-semibold text-ink-900">
          Approval Required
        </h2>

        <p className="mt-2 text-center text-sm text-ink-600">
          The agent wants to execute a high-risk action:
        </p>

        {/* Tool info */}
        <div className="mt-4 rounded-xl border border-ink-100 bg-surface-1 p-4">
          <div className="flex items-center gap-2">
            <span className="badge-amber">High Risk</span>
            <span className="text-sm font-medium text-ink-800">{toolName}</span>
          </div>
          <p className="mt-2 text-sm text-ink-600">{prompt}</p>
        </div>

        {/* Actions */}
        <div className="mt-6 flex gap-3">
          <button onClick={onReject} className="btn-secondary flex-1">
            Reject
          </button>
          <button onClick={onApprove} className="btn-primary flex-1">
            Approve
          </button>
        </div>
      </div>
    </div>
  );
}
